export default (search) => (
  new URLSearchParams(search).get('term')
);
